// Biometric unlock is a native-shell concern; unavailable in the browser.
export async function isBiometricAvailable() {
  return false;
}
export async function verifyBiometric() {
  return true;
}
